import getCurrentUrl from './utils/getCurrentUrl';
import buildAuthorizationUrl from './utils/buildAuthorizationUrl';

var getLoginUrl = function getLoginUrl(authServerConfig, clientConfig, redirectUri) {
  return buildAuthorizationUrl(Object.assign({
    responseType: 'none',
    redirectUri: redirectUri || getCurrentUrl(window.location.href)
  }, clientConfig), authServerConfig);
};

export { getLoginUrl };